import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import user from '@/store/user';
import universe from '@/store/universe';
import chart from '@/store/chart';
import ui from '@/store/ui';

Vue.use(Vuex);

const apiBaseUrl = 'https://lcp-select-app-prod.azurewebsites.net/api';
const lcpColors = [
    'rgb(0,163,199)',
    'rgb(0,47,95)',
    'rgb(141,168,173)',
    'rgb(223,63,111)',
    'rgb(247,166,0)',
    'rgb(213,220,93)',
    'rgb(1,83,87)',
    'rgb(0,143,143',
    'rgb(89,89,154)',
    'rgb(232,192,220)',
    'rgb(130,26,77)',
];
const managerColors = {};

function getManagerColor (ticker) {
    if (managerColors[ticker] === undefined) {
        if (lcpColors[Object.keys(managerColors).length] !== undefined) {
            managerColors[ticker] = lcpColors[Object.keys(managerColors).length];
        } else {
            managerColors[ticker] = `rgb(${Math.floor(Math.random() * Math.floor(255))} , ${Math.floor(Math.random() * Math.floor(255))} , ${Math.floor(Math.random() * Math.floor(255))} )`;
        }
    }
    return managerColors[ticker];
}

export default new Vuex.Store({
    modules: {
        chart,
        ui,
        universe,
        user,
    },
    state: {
        activeCategories: [],
        addedCircle: [],
        categoryFilter: [],
        pensionsData: [],
        searchCriteria: '',
        selectedManagers: [],
        testResults: {},
        valueFilter: [],
    },
    getters: {
        getPensionsData: state => state.pensionsData,
        getColourSelection: state => state.colourSelection,
        getCategoryFilter: state => state.categoryFilter,
        getValueFilter: state => state.valueFilter,
        getActiveCategories: state => state.activeCategories,
        getAddedCircle: state => state.addedCircle,
        getUnDeletedSelectedMangers: (state) => {
            const managers = [];
            for (const n in state.selectedManagers) {
                if (!state.selectedManagers[n].deleted) {
                    managers.push(state.selectedManagers[n]);
                }
            }
            return managers;
        },
        getXaxisSelection: state => state.chart.xAxisSelection,
        getYaxisSelection: state => state.chart.yAxisSelection,
        getRaxisSelection: state => state.chart.raxisSelection,
    },
    mutations: {
        updatePensionsData (state, responseData) {
            if (responseData.valueDimensions != null) {
                state.pensionsData = responseData;
                for (let j = 0; j < state.pensionsData.valueFilter.length; j += 1) {
                    let found = false;
                    for (let f = 0; f < state.valueFilter.length; f += 1) {
                        if (state.valueFilter[f].valueName === state.pensionsData.valueFilter[j].valueName) {

							const max = Math.max(
                                state.valueFilter[f].values[0],
                                state.pensionsData.valueFilter[j].values[0],
							);
							const min = Math.min(
                                state.valueFilter[f].values[0],
                                state.pensionsData.valueFilter[j].values[1],
							);

							Vue.set(state.pensionsData.valueFilter, [j].values[0], max);
							Vue.set(state.pensionsData.valueFilter, [j].values[1], min);

                            found = true;
                        }
                    }
                    if (!found) {
                        state.valueFilter.push({
                            valueName: state.pensionsData.valueFilter[j].valueName,
                            values: state.pensionsData.valueFilter[j].values,
                        });
                    }
                }
            } else {
                state.pensionsData.data = responseData.data;
                state.pensionsData.keyData = responseData.keyData;
                state.pensionsData.minimumDate = responseData.minimumDate;
                state.pensionsData.maximumDate = responseData.maximumDate;
            }
            state.ui.pageState = 'loaded';
            state.ui.loadState = 'loaded';

            state.ui.pageView = state.ui.pageView === 'search' ? 'home' : state.ui.pageView;
            if (state.chart.xAxisSelection === '') {
                state.chart.xAxisSelection = responseData.initialX;
                state.chart.yAxisSelection = responseData.initialY;
                state.chart.raxisSelection = responseData.initialR;
                state.chart.colourSelection = responseData.initialColour;
            }
        },
        updateCategoryFilter (state, updateData) {
            state.categoryFilter = updateData;
        },
        updateValueFilterElement (state, updateData) {
            let found = false;
            for (let j = 0; j < state.valueFilter.length; j += 1) {
                if (state.valueFilter[j].valueName === updateData.name) {
                    Vue.set(state.valueFilter[j], 'values', updateData.newValue);
                    found = true;
                }
            }

            if (!found) {
                state.valueFilter.push({
                    valueName: updateData.name,
                    values: updateData.newValue,
                });
            }
        },
        updateActiveCategories (state, updateData) {
            state.activeCategories = updateData;
        },
        updateAddedCircle (state, updateData) {
            state.AddedCircle = updateData;
        },
        loadManagerData (data) {
            this.commit('loadManagerData', data);
        },
        managerView (state) {
            state.ui.pageView = 'managers';
        },
        toggleManagerComparison (state, data) {
            state.selectedManagers[data.arrayIndex].comparison = !state.selectedManagers[data.arrayIndex].comparison;
        },
        setManagerDeleted (state, data) {
            // Vue.set(state.selectedManagers[data.arrayIndex], 'deleted', true);
            state.selectedManagers[data.arrayIndex].deleted = true;
            state.ui.managerDeleted = true;
        },
        removeManagers (state) {
            let i = state.selectedManagers.length;
            while (i--) {
                if (state.selectedManagers[i].deleted) {
                    state.selectedManagers.splice(i, 1);
                }
            }
        },
        wipeManagers (state) {
            state.selectedManagers = [];
        },
        removeManager (state, ticker) {
            const fundIndex = state.selectedManagers.findIndex(x => x.ticker === ticker);
            state.selectedManagers.splice(fundIndex, 1);
        },
        updateManagerComparison (state, data) {
            state.ui.ManagerComparison = data;
            data ? (state.ui.pageView = 'ManagerComparison') : (state.ui.pageView = 'managers');
        },
        updateSearch (state, data) {
            state.searchCriteria = data;
            state.ui.pageView = 'search';
        },
        closeSearch (state) {
            state.ui.pageView = 'home';
            state.searchCriteria = '';
        },
        dropdownSelection (state, data) {
            Vue.set(state, data.name, data.option);
        },
        dropdownSelectionMulti (state, data) {
            let found = false;
            for (let j = 0; j < state.categoryFilter.length; j += 1) {
                if (state.categoryFilter[j].categoryName === data.name) {
                    Vue.set(state.categoryFilter[j], 'selectedOrder', data.options);
                    found = true;
                }
            }

            if (!found) {
                state.categoryFilter.push({
                    categoryName: data.name,
                    selectedOrder: data.options,
                });
            }
        },
        addToManagers (state, data) {
            data.color = getManagerColor(data.ticker);
            data.deleted = false;
            state.selectedManagers.push(data);

            const stringManagers = JSON.stringify(state.selectedManagers);
            localStorage.setItem('localManagers', stringManagers);
        },
        commitDailyData (state, data) {
            for (const fn in data) {
                // vue.set()
                for (const selFun in state.selectedManagers) {
                    if (state.selectedManagers[selFun].ticker === fn) {
                        state.selectedManagers[selFun].dailyData = data[fn];
                    }
                }
            }
            state.ui.testAdded = true;
            setTimeout(() => {
                state.ui.testAdded = false;
            }, 2000);
        },
        updateRating (state, data) {
            state.pensionsData.data[data.arrayIndex].values[5] = data.rating;
            state.pensionsData.keyData[data.ticker].values[5] = data.rating;
        },
        updateBulkRatings (state, newRating) {
            for (let k = 0; k < state.chart.visiblePoints[0].length; k += 1) {
                const obj = state.chart.visiblePoints[0][k];
                const index = state.pensionsData.data.findIndex(x => x.id === obj.id);
                const rating = state.pensionsData.data[index].values[5] + newRating;
                const selectedArray = {
                    arrayIndex: index,
                    rating,
                    ticker: obj.ticker,
                    guid: obj.id,
                };
                state.pensionsData.data[selectedArray.arrayIndex].values[5] = selectedArray.rating;
                state.pensionsData.keyData[selectedArray.guid].values[5] = selectedArray.rating;
            }
        },
        showTestTable (state, tests) {
            state.ui.pageView = 'testTable';
            state.testResults = tests;
        },
        backToTestsTable (state) {
            state.ui.pageView = 'testTable';
        },
        resetValueFilter (state) {
            for (let j = 0; j < state.universe.data.valueFilter.length; j += 1) {
                for (let f = 0; f < state.valueFilter.length; f += 1) {
                    if (state.valueFilter[f].valueName === state.universe.data.valueFilter[j].valueName) {
                        Vue.set(state.valueFilter[j].values, [0], state.universe.data.valueFilter[j].min);
                        Vue.set(state.valueFilter[j].values, [1], state.universe.data.valueFilter[j].max);
                    }
                }
            }
        },
        resetCategoryFilter (state) {
            state.categoryFilter = [];
        },
    },
    actions: {
        loadManagerData ({ commit, state, dispatch }, dateValues) {
            if (state.ui.pageView === 'managers' || state.ui.pageView === 'managersComparison') {
                return dispatch('updateDailyDataFirst', dateValues);
            }
            return dispatch('updateManagerDataFirst', dateValues);
        },
        async updateDailyDataFirst ({ dispatch }, dateValues) {
            await dispatch('updateDailyData', dateValues);
            await dispatch('updateChartScatterData', dateValues);
        },
        async updateManagerDataFirst ({ dispatch }, dateValues) {
            await dispatch('updateChartScatterData', dateValues);
            await dispatch('updateDailyData', dateValues);
        },
        async updateChartScatterData ({ commit, dispatch, state }, dateValues) {
            const response = await axios.post(`${apiBaseUrl}/getChartData`, { startDate: dateValues[0], endDate: dateValues[1], allData: state.universe.allData});
            if (state.ui.loadState === 'loading') {
				commit('ui/updateDates', [response.data.minimumDate, response.data.maximumDate]);
				commit('ui/updateSliderDates', response.data.sliderDates);
			}
			await commit('updatePensionsData', response.data);
            await dispatch('universe/setUniverse');
        },
        async updateDailyData ({ commit, state }, dateValues) {
            const funds = [];
            for (const fn in state.selectedManagers) {
                funds.push(state.selectedManagers[fn].ticker);
            }
            const response = await axios.post(`${apiBaseUrl}/getDailyData`, { fundIds: funds, startDate: dateValues[0], endDate: dateValues[1] });
            await commit('commitDailyData', response.data);
        },
        async addManagerData ({ commit, state }, managerData) {
            await commit('addToManagers', managerData);
            const startDate = state.pensionsData.minimumDate;
            const endDate = state.pensionsData.maximumDate;
            const response = await axios.post(`${apiBaseUrl}/getDailyData`, { fundIds: [managerData.ticker], startDate, endDate });
            await commit('commitDailyData', response.data);
        },
    },
});
